import React from 'react';
import { Row, Col } from 'antd';
import { ReactComponent as BackIcon } from 'assets/icons/back_arrow.svg';
import { ReactComponent as CopyIcon } from 'assets/icons/duplicate_without_fill.svg';
import { EditOrganisationMapEnum } from 'enums/organisationMapEnums';
import styles from './editOrganisationMap.module.scss';
import { OrganisationMapPayload } from 'models/CompanySetup/organisationPayload.model';
import { OrganizationDataModel } from 'models/CompanySetup/organizationDataModel.model';
import { OptionsMeta } from 'models/MetaData/metaData.model';

interface EditOrganisationHeaderProps {
  handleBack: () => void;
  handleModalOpen: () => void;
  organisationYearsList: OptionsMeta[];
  organisationMapData: OrganisationMapPayload;
  organizationData: OrganizationDataModel | null;
  canEditMap?: boolean;
}

const EditOrganisationHeader: React.FC<EditOrganisationHeaderProps> = ({
  handleBack,
  handleModalOpen,
  organisationYearsList,
  organisationMapData,
  organizationData,
  canEditMap = true,
}) => {
  return (
    <Row className={styles.editOrganisationHeader}>
      <Col span={12} className={styles.editOrganisationHeaderLeft}>
        <Row className={styles.editMapHeaderTitle}>
          <div className={styles.backButtonContainer} onClick={handleBack}>
            <BackIcon />
          </div>
          {EditOrganisationMapEnum.EDIT_MAP_TITLE}
        </Row>
        <Row className={styles.editMapHeaderInfo}>
          <span>
            {EditOrganisationMapEnum.EDIT_MAP_INFO}
            <span className={styles.bold}>
              {EditOrganisationMapEnum.EDIT_MAP_PARENT_INFO}
            </span>
          </span>
        </Row>
      </Col>
      <Col span={12} className={styles.editOrganisationHeaderRight}>
        <Row
          gutter={[20, 20]}
          className={styles.editOrganisationHeaderRightContainer}
          justify={'end'}>
          {organisationYearsList?.length > 1 && (
            <Col>
              <Row
                className={styles.duplicateMapContainer}
                onClick={canEditMap ? handleModalOpen : undefined}
                style={{
                  opacity: canEditMap ? 1 : 0.6,
                  cursor: canEditMap ? 'pointer' : 'not-allowed',
                }}>
                <CopyIcon />
                <div>{EditOrganisationMapEnum.DUPLICATE_MAP_BUTTON_TITLE}</div>
              </Row>
            </Col>
          )}
          <Col>
            <Row gutter={[10, 10]} className={styles.organisationBoundaryInfo}>
              <Col className={styles.organisationBoundaryTitle}>
                {EditOrganisationMapEnum.ORGANISATIONAL_BOUNDARY_LABEL}
              </Col>
              <Col className={styles.organisationBoundaryValue}>
                {((organisationMapData.organizationMap?.length &&
                  organisationMapData.organizationMap[0].company
                    ?.organizationalBoundary) ||
                  organizationData?.company?.organizationalBoundary) ??
                  ''}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default EditOrganisationHeader;
